import React, { useEffect, useState } from 'react';
import {
  Grid,
  CircularProgress,
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  TableBody,
  TablePagination,
  Tooltip,
  Typography,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import NetworkTabs from '../Component/NetworkTabs';
import CummulativeData from '../Component/CummulativeData';

import { getNetworkInfoList } from '../action';
import { getBuyerRolesAction } from '../../Onboarding/auth/action';
import IndustryAndCompanyPicker from '../Component/IndustryAndCompanyPicker';
import { Info } from '@mui/icons-material';

const VcpPerformanceDirectory = () => {
  const navigate = useNavigate();

  const [networkListData, setNetworkListData] = useState({});
  const [loading, setLoading] = useState(false);
  const [onboardBuyerRoleData, setOnboardBuyerRoleData] = useState([]);
  const [selectedFirm, setSelectedFirm] = useState({
    firm_role_id: null,
    firm_role_type: '',
  });

  const { company_details, comapny_entity_id } = useSelector((state) => ({
    company_details: state.reportReducer.company_details,
    comapny_entity_id: state.reportReducer.comapny_entity_id,
  }));

  const getOnboardBuyerRoles = async () => {
    const { data, error, message } = await getBuyerRolesAction(
      Number(company_details?.id),
      false,
      true,
      true,
    );

    if (!error) {
      const influencerRoles = data.roles.filter(
        ({ region_role_id }) => region_role_id === null,
      );

      const updatedRoles = data.roles
        .filter(({ region_role_id }) => region_role_id !== null)
        .concat(
          influencerRoles.length > 0
            ? {
                display_name: 'Influencer Sales Allocated',
                firm_role_id: null,
                firm_role_type: 'INFLUENCER',
              }
            : [],
        );
      setOnboardBuyerRoleData(updatedRoles);
    } else {
      toast.error(message);
    }
  };

  const getNetworkInfoData = async () => {
    if (!company_details?.id || !selectedFirm.firm_role_type) return;

    const payload = {
      manufacturer_id: company_details.id,
      firm_role_type: selectedFirm.firm_role_type,
      user_company_esi_id: comapny_entity_id,
      ...(selectedFirm.firm_role_id !== null && {
        firm_role_id: selectedFirm.firm_role_id,
      }),
    };
    setLoading(true);

    const { data, error, message } = await getNetworkInfoList(payload);
    if (!error) {
      setNetworkListData(data);
    } else {
      toast.error(message);
    }
    setLoading(false);
  };
  useEffect(() => {
    if (onboardBuyerRoleData.length > 0 && !selectedFirm.firm_role_type) {
      setSelectedFirm({
        firm_role_id: onboardBuyerRoleData[0].firm_role_id,
        firm_role_type: onboardBuyerRoleData[0].firm_role_type,
      });
    }
  }, [onboardBuyerRoleData]);

  useEffect(() => {
    if (company_details?.id) {
      getOnboardBuyerRoles();
    }
  }, [company_details?.id]);
  useEffect(() => {
    if (selectedFirm.firm_role_type && company_details?.id && comapny_entity_id) {
      getNetworkInfoData();
    }
  }, [selectedFirm, company_details?.id, comapny_entity_id]);
  const tableCellStyles = {
    borderRight: '1px solid #ddd',
    fontSize: 12,
    textAlign: 'center',
    padding: '10px',
  };

  const headerCellStyles = {
    ...tableCellStyles,
    fontSize: 14,
    fontWeight: 600,
    backgroundColor: '#f5f5f5',
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const paginatedData = Array.isArray(networkListData?.vcp_wise_sales)
    ? networkListData?.vcp_wise_sales?.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage,
      )
    : [];

  return (
    <Box sx={{ p: { xs: 2, md: 4 } }}>
      <Typography variant="h2" sx={{ mb: 3, fontWeight: 'bold' }}>
        Network Performance
      </Typography>
      <IndustryAndCompanyPicker />
      <Grid
        container
        spacing={2}
        alignItems='stretch'
      >
        <Grid
          item
          xs={12}
          md={8}
        >
          <NetworkTabs
            networkList={onboardBuyerRoleData}
            setSelectedFirm={setSelectedFirm}
            setPage={setPage}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <CummulativeData networkListData={networkListData} />
        </Grid>

        <Grid
          item
          xs={12}
        >
          {loading ? (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '50vh',
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
              <TableContainer>
                <Table sx={{ border: '1px solid #ddd' }}>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={headerCellStyles}>Name</TableCell>
                      <TableCell sx={headerCellStyles}>State</TableCell>
                      <TableCell sx={headerCellStyles}>District</TableCell>
                      <TableCell sx={headerCellStyles}>UOM</TableCell>
                      <TableCell sx={headerCellStyles}>
                        This Month's Sales
                      </TableCell>
                      <TableCell sx={headerCellStyles}>
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Typography
                            sx={{ fontWeight: 'bold', fontSize: '14px' }}
                          >
                            YTD Sales
                          </Typography>
                          <Tooltip
                            title='Launch wise onwards'
                            arrow
                            placement='top'
                            enterTouchDelay={0}
                            leaveTouchDelay={1500}
                            disableFocusListener={false}
                            disableTouchListener={false}
                          >
                            <Info
                              sx={{
                                fontSize: 16,
                                marginLeft: 1,
                                cursor: 'pointer',
                              }}
                            />
                          </Tooltip>
                        </Box>
                      </TableCell>
                      {selectedFirm.firm_role_type !== 'INFLUENCER' && (
                        <TableCell sx={headerCellStyles}>
                          Network Influencer
                        </TableCell>
                      )}

                      <TableCell sx={headerCellStyles}>Status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paginatedData.length > 0 ? (
                      paginatedData.map((item, rowIndex) => (
                        <TableRow
                          key={rowIndex}
                          sx={{
                            cursor: 'pointer',
                            '&:hover': { backgroundColor: '#f5f5f5' },
                          }}
                          onClick={() =>
                            navigate('/my-performance/VCPSalesDashBoard', {
                              state: {
                                company_id: item?.company_id,
                                selectedRole: selectedFirm.firm_role_type,
                              },
                            })
                          }
                        >
                          <TableCell sx={tableCellStyles}>
                            {item?.company_name}
                          </TableCell>
                          <TableCell sx={tableCellStyles}>
                            {item?.state}
                          </TableCell>
                          <TableCell sx={tableCellStyles}>
                            {item?.district}
                          </TableCell>
                          <TableCell sx={tableCellStyles}>
                            {item?.prefix_uom || item?.suffix_uom}
                          </TableCell>
                          <TableCell sx={tableCellStyles}>
                            {item?.current_month_sales}
                          </TableCell>
                          <TableCell sx={tableCellStyles}>
                            {item?.total_sales_ytd}
                          </TableCell>
                          {selectedFirm.firm_role_type !== 'INFLUENCER' && (
                            <TableCell sx={tableCellStyles}>
                              {item?.active_influencers}
                            </TableCell>
                          )}
                          <TableCell sx={tableCellStyles}>
                            <Box
                              sx={{
                                display: 'inline-block',
                                padding: '4px 10px',
                                borderRadius: '12px',
                                backgroundColor: item?.color,
                                color: '#fff',
                              }}
                            >
                              {item?.status}
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={8}
                          align='center'
                          sx={{ fontSize: 12 }}
                        >
                          No data available
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <TablePagination
                  rowsPerPageOptions={[10, 20, 25]}
                  component='div'
                  count={networkListData?.vcp_wise_sales?.length || 0}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Box>
            </Paper>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default VcpPerformanceDirectory;
